import { StrictMode } from "react"

import { IDirective } from "angular"
import { createRoot } from "react-dom/client"

import MetricListController from "../../app/controllers/metric-list/metric-list.controller"
import { MetricsPage } from "./MetricsPage"

export function MetricsPageDirective(): IDirective {
  return {
    restrict: "E",
    controller: "MetricListController",
    link: function (scope, element, _attributes, controller) {
      const root = createRoot(element[0])
      root.render(
        <StrictMode>
          <MetricsPage controller={controller as MetricListController} />
        </StrictMode>,
      )

      // Clean up React component when the Angular component is destroyed
      scope.$on("$destroy", () => {
        root.unmount()
      })
    },
  }
}
